import {RouteView, PageView} from '@/layouts'

export const exception = {
    path: '/exception',
    name: 'exception',
    component: PageView,
    redirect: '/exception/403',
    meta: {title: '异常页', icon: 'warning',},
    children: [
        {
            path: '/exception/403',
            name: 'Exception403',
            component: () => import('@/views/exception/403'),
            meta: {title: '403', exception: true}
        },
        {
            path: '/exception/404',
            name: 'Exception404',
            component: () => import('@/views/exception/404'),
            meta: {title: '404', exception: true}
        },
        {
            path: '/exception/500',
            name: 'Exception500',
            component: () => import('@/views/exception/500'),
            meta: {title: '500', exception: true}
        }
    ]
}
